<template>

  <Dialog
      :style="{width: '43vw'}"
      v-model:visible="computedVisible"
      :modal="true"
      :closable="true">

    <div id="overlay" v-if="overlay"></div>

    <template #header>
      <h3>Distribuidor {{ distributor && distributor.tdistribuidor }}</h3>
    </template>

    <TabView :activeIndex="activeIndex" scrollable>

      <!--      Tab 1 -->
      <TabPanel>
        <template #header>
          <i class="pi pi-home icon"></i>
          <span class="tab-title">&nbsp;&nbsp;Detalles</span>
        </template>
        <Tab1
            :distributor="distributor"
            @close="closeDialog"/>
      </TabPanel>

      <!--        Tab 2 -->
      <TabPanel>
        <template #header>
          <i class="pi pi-percentage icon"></i>
          <span class="tab-title">&nbsp;&nbsp;Porcentajes</span>
        </template>
        <Tab2
            :distributor="distributor"
            @close="closeDialog"
        />
      </TabPanel>

      <!--      Tab 3 -->
      <TabPanel>
        <template #header>
          <i class="pi pi-exclamation-triangle icon"></i>
          <span class="tab-title">&nbsp;&nbsp;Cupos</span>
        </template>
        <Tab3 :distributor="distributor"/>
      </TabPanel>

      <!--      Tab 4 -->
      <TabPanel>
        <template #header>
          <i class="pi pi-directions icon"></i>
          <span class="tab-title">&nbsp;&nbsp;Apuesta</span>
        </template>
        <Tab4 :distributor="distributor"/>
      </TabPanel>

      <!--      Tab 5 -->
      <TabPanel>
        <template #header>
          <i class="pi pi-directions icon"></i>
          <span class="tab-title">&nbsp;&nbsp;Misceláneos</span>
        </template>
        <Tab5 :distributor="distributor"/>
      </TabPanel>

      <!--      Tab 6 -->
      <TabPanel :disabled="Number(distributor.num_agencias) === 0">
        <template #header>
          <i class="pi pi-directions icon"></i>
          <span class="tab-title">&nbsp;&nbsp;Agencias ({{ distributor.num_agencias }})</span>
        </template>
        <Tab6 :distributor="distributor"
              @close="closeDialog"/>
      </TabPanel>

    </TabView>


    <template #footer>
      <!--      <Button label="No" icon="pi pi-times" class="p-button-text"/>-->
      <!--      <Button label="Yes" icon="pi pi-check" autofocus/>-->
    </template>
  </Dialog>

</template>

<script>
import generalMixin from "@/mixins/generalMixin";
import Tab1 from "@/components/Settings/Distributors/Dialog/Tab1";
import Tab2 from "@/components/Settings/Distributors/Dialog/Tab2";
import Tab3 from "@/components/Settings/Distributors/Dialog/Tab3";
import Tab4 from "@/components/Settings/Distributors/Dialog/Tab4";
import Tab5 from "@/components/Settings/Distributors/Dialog/Tab5";
import Tab6 from "@/components/Settings/Distributors/Dialog/Tab6.vue";

export default {
  name: "EditDistributorDialog",
  components: {
    'Tab1': Tab1,
    'Tab2': Tab2,
    'Tab3': Tab3,
    'Tab4': Tab4,
    'Tab5': Tab5,
    'Tab6': Tab6,
  },
  props: {
    show: Boolean,
    distributor: Object,
    distributorDetails: Object,
  },
  mixins: [generalMixin],
  data() {
    return {
      activeIndex: 0,
      overlay: false,
    }
  },
updated() {
    console.log(this.distributor)
},
  methods: {
    closeDialog() {
      this.$emit('close');
    }
  },
  computed: {
    computedVisible: {
      get() {
        return this.show
      },
      set() {
        this.$emit('close')
      }
    },
  }
}
</script>

<style scoped lang="scss">

.icon {
  //color: var(--green-banklot);
}
.tab-title {
  color: var(--green-banklot);
}
</style>
